export function framePostMessage(iframeId: string, message: any) {
  const iframe = document.getElementById(iframeId) as HTMLIFrameElement;
  const jsonStringify = JSON.stringify(message);
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(jsonStringify, "*");
  }
}
